const DeleteBtn = (callback, deleteRecord, selectedProject) => {
    return (
        {
            isDeletable: rowData => rowData,
            onRowDelete: async (rowData) => {
                // make sure to await this...
                await deleteRecord(selectedProject, rowData)
                callback(new Date());
            }
        }
    )
}

export default DeleteBtn